import script from "./DetailAssigment.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailAssigment.vue?vue&type=script&setup=true&lang=js"

import "./DetailAssigment.vue?vue&type=style&index=0&id=b356b504&scoped=true&lang=scss"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b356b504"]])

export default __exports__